import {ChangeDetectorRef, Component} from '@angular/core';
import {AbstractProdGrid, IProdGrid, ProdGridColumnTransforms, ProdGridColumnType} from 'prod-grid';
import {DipColumn} from "../../dip/dip-column";
import {CommunicationLogService} from "../../services/communication-log.service";
import {HttpExtraParams} from "prod-shared";
import {OrganizationTreeSelect} from "../../dip/organization-tree-select";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-communication-log',
  templateUrl: './communication-log.component.html'
})
export class CommunicationLogComponent extends AbstractProdGrid implements IProdGrid {
  prodGridTitle: string = this.translate.instant('communication_log.grid_title');
  prodGridColumns: DipColumn[] = [
    DipColumn.get({property: 'id', type: ProdGridColumnType.ID}),
    DipColumn.get({
        property: 'vhmdId', type: ProdGridColumnType.NUMBER
      }
    ),
    DipColumn.get({
      property: 'vhmdCounter', type: ProdGridColumnType.NUMBER
    }),
    DipColumn.get({
      property: 'rssi', type: ProdGridColumnType.FLOAT
    }),
    DipColumn.get({
      property: 'vhmhId', type: ProdGridColumnType.NUMBER
    }),
    DipColumn.get({
      property: 'vhmhCounter', type: ProdGridColumnType.NUMBER
    }),
    DipColumn.get({
      property: 'voltage', type: ProdGridColumnType.FLOAT,
      postfix: 'V',
      transform: {transform: ProdGridColumnTransforms.ZERO_PADDING, option: 3}
    }),
    DipColumn.get({
      property: 'ignition', type: ProdGridColumnType.CHECKBOX,
      transform: {
        transform: ProdGridColumnTransforms.TICK
      }
    }),
    DipColumn.get({
      property: 'charger', type: ProdGridColumnType.CHECKBOX,
      transform: {
        transform: ProdGridColumnTransforms.TICK
      }
    }),
    DipColumn.get({
      property: 'macAddress', type: ProdGridColumnType.STRING
    }),
    DipColumn.get({
      property: 'createdAt', type: ProdGridColumnType.DATE,
      transform: {
        transform: ProdGridColumnTransforms.DATETIME
      }
    }),
  ];

  constructor(protected override changeDetectorRef: ChangeDetectorRef,
              override prodGridDataService: CommunicationLogService,
              private organizationTreeSelect: OrganizationTreeSelect,
              private translate: TranslateService) {
    super(changeDetectorRef);
    organizationTreeSelect.gridComponent = this;
  }

  override ngOnInit(): void {
    super.ngOnInit();
  }

  ngOnDestroy() {
    this.organizationTreeSelect.gridComponent = null;
  }

  override loadProdGridData(httpExtraParams?: HttpExtraParams): void {
    super.loadProdGridData(HttpExtraParams.addFilter(httpExtraParams, this.organizationTreeSelect.getHttpExtraParams(this.prodGridDataService)));
  }
}
